import React from 'react';
import { Icon } from 'semantic-ui-react';
import { WorkflowStatusType } from '@constants/workflowStatus';

function StatusIcon({ statusValue }: { statusValue: WorkflowStatusType }) {
  if (statusValue) {
    const { icon, color } = statusValue;
    return <Icon name={icon} color={color} size="large" />;
  }
  return null;
}

export default StatusIcon;
